<!-- Company specific file vault -->
<app-filelist [companyId]="companyId"></app-filelist>
